import InternetError from './internet-error';

export default InternetError;
